export default "__VITE_ASSET__CRIxRw7Y__"